import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "formik";
import Error from "./Error";

const FormField = props => {
  const { name, classes, children } = props;
  return (
    <div className={classes}>
      {children}
      <ErrorMessage name={name} render={msg => <Error text={msg} />} />
    </div>
  );
};

FormField.propTypes = {
  name: PropTypes.string.isRequired,
  classes: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

FormField.defaultProps = {
  classes: "form-item"
};

export default FormField;
